module.exports = __webpack_public_path__ + "media/images/manifest/microbius-180-9d74f95dd3f9684c5a01696496eb07b6.png";